<template>
  <div class="accordion-item">
    <div 
      class="flex items-center justify-between py-3 cursor-pointer hover:bg-accent/50 transition-colors"
      @click="toggle"
    >
      <div class="text-sm">
        <slot name="trigger"></slot>
      </div>
      <ChevronDownIcon 
        class="h-4 w-4 text-muted-foreground transition-transform"
        :class="{ 'transform rotate-180': isOpen }"
      />
    </div>
    <div 
      v-show="isOpen"
      class="py-2"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject, computed, ref } from 'vue'
import { ChevronDownIcon } from '@heroicons/vue/24/outline'

const props = defineProps<{
  itemId: string
}>()

const accordion = inject('accordion') as {
  openItems: string[]
  toggleItem: (itemId: string) => void
} | null

// Fallback if injection fails
const isOpen = computed(() => {
  if (!accordion?.openItems) return false
  return Array.isArray(accordion.openItems) && accordion.openItems.includes(props.itemId)
})

const toggle = () => {
  if (accordion?.toggleItem) {
    accordion.toggleItem(props.itemId)
  }
}
</script> 